import React from 'react';
import './ExternalTermsandConditionLink.css';

import {
  getEnv
} from '../../Utility/utility';

export const ExternalTermsandConditionLink = () => {
  return (

    <div className="embed-container">
      <embed src={`https://www${getEnv()}.vodacom.co.za/vodacom/terms/fibre/vodacom-fibre?displayMode=page`}
      width="100%"
      height="100%"/>
    </div>

  )
}

export default ExternalTermsandConditionLink;
